// extracted by mini-css-extract-plugin
export var equalColumn = "_ix-0";